'use client';
import React from 'react';
import Accordion, { TAccodionData } from '@/ui/Accordion';

const FaqSection: React.FC<{ faqs: TAccodionData }> = ({ faqs }) => {
  return <Accordion data={faqs} />;
};

export default FaqSection;
